var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"pa-0 ma-0",attrs:{"cols":"12","md":"8","lg":"6"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }